// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"2d020839","769":"d66d9710"}[chunkId] + ".chunk.js";
};